import {Helmet} from 'react-helmet-async';
import {Container} from '@mui/material';
import CustomBreadcrumbs from "../custom-breadcrumbs";
import {useLocales} from "../../locales";

export default function PageHeaderWrapper({
                                              titleKey,
                                              headingKey,
                                              links = [],
                                              action = null,
                                              children
                                          }) {

    const {translate} = useLocales();
    return (
        <>
            <Helmet>
                <title>BUS Soft - {translate(titleKey)}</title>
            </Helmet>

            <Container maxWidth={false} disableGutters>
                <CustomBreadcrumbs
                    heading={translate(headingKey)}
                    links={links}
                    action={action}
                />

                {children}
            </Container>
        </>
    );
}
